import { supabase } from '../supabase';

export async function sendPasswordResetEmail(email: string): Promise<void> {
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/auction/reset-password`,
    });
    
    if (error) {
      throw new Error(error.message);
    }
    
    console.log(`Password reset email sent to: ${email}`);
  } catch (error) {
    console.error('Password reset error:', error);
    throw error;
  }
}

export async function resetPassword(newPassword: string): Promise<void> {
  try {
    const { error } = await supabase.auth.updateUser({
      password: newPassword
    });
    
    if (error) {
      throw new Error(error.message);
    }
  } catch (error) {
    console.error('Password update error:', error);
    throw error;
  }
}